import React from 'react';
import { Button, Dropdown } from 'antd';

/**
 * An agent's name as a link to their summary page.
 *
 * A dropdown rather than a plain link because these sit in dense tables people
 * read across: opening in a new tab is usually what you want, and a plain
 * anchor makes that a right-click someone has to know about.
 *
 * `canNavigate` is the caller's CanViewAgentSummary check. When it is false the
 * name still renders, just as text -- a row should not lose its label because
 * the reader cannot follow it.
 *
 * `jobName`, where given, renders as a caption under the name. `badge`, where
 * given, sits on that same caption line.
 */
export default function AgentLink({ name, jobName, url, navigate, canNavigate = true, badge = null }) {
  const menuItems = [
    { key: 'open',    label: 'Open',            onClick: () => navigate(url) },
    { key: 'new-tab', label: 'Open in new tab', onClick: () => window.open(url, '_blank') },
  ];
  return (
    <div>
      {canNavigate ? (
        <Dropdown menu={{ items: menuItems }} trigger={['click']}>
          <Button type="link" size="small" style={{ padding: 0, textAlign: 'left', height: 'auto' }}>
            {name}
          </Button>
        </Dropdown>
      ) : (
        <span>{name}</span>
      )}
      {(jobName || badge) && (
        <div style={{ fontSize: 11, color: '#8c8c8c', display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
          {jobName}{badge}
        </div>
      )}
    </div>
  );
}
